import React 				from 'react';

import {Address} 			from '../../redux/address/interface';
import {User} 				from '../../redux/user/interface';


type BytesUnit = 'Bytes' | 'KB' | 'MB' | 'GB' | 'TB' | 'PB' | 'EB' | 'ZB' | 'YB'

export function ft_formatBytes(size: number, unit: BytesUnit = 'Bytes', decimals = 2): string {
	const sizes: BytesUnit[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	const unitIndex = sizes.indexOf(unit);

	const k = 1024;
	const dm = decimals < 0 ? 0 : decimals;

	const bytes = size * (k ** unitIndex);

	const i = Math.floor(Math.log(bytes) / Math.log(k));

	return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
}

export function ft_formatOrderId(valalaNumber: string, withPrefix = true) {
	return `${withPrefix ? 'CO' : ''}${valalaNumber}`;
}

export function ft_formatPrice(price: string | number | undefined, withSymbol = true) {
	if (price === undefined)
		return '';
	const finalPrice = typeof price === 'string' ? parseFloat(price) : price;

	if (isNaN(finalPrice))
		return `??${withSymbol ? '€' : ''}`;
	return `${finalPrice.toFixed(2).replace('.', ',')}${withSymbol ? '€' : ''}`;
}

export function ft_formatUserName(user: User | undefined, firstnameOnly?: boolean) {
	if (!user)
		return '';
	if (firstnameOnly)
		return `${user.firstname || ''}`;
	return `${user.firstname || ''} ${user.lastname || ''}`;
}

export function ft_formatAddressInline(address: Address | undefined, reduce?: boolean) {
	if (!address)
		return <span />;

	if (reduce)
		return (<span>{`${address.street} ${address.postalCode}, ${address.city} ${address.country}`}</span>);

	return (
		<span className={'weight-400'}>
			<span className={'gray-900'}>{`“${address.name}“`}</span>
			{` ${address.street} - ${address.postalCode} ${address.city} - ${address.country}`}
		</span>
	);
}

export function ft_formatMemorySize(memory: string) : number {
	const quantity = parseInt(memory, 10);

	if (memory.toLowerCase().includes('to'))
		return quantity * 1000;
	return quantity;
}

export function ft_formatFirstUpperCase(text?: string | null) : string {
	if (!text || text === '')
		return '';
	return `${text.charAt(0).toLocaleUpperCase()}${text.slice(1)}`;
}

export function ft_formatFirstLowerCase(text?: string | null) : string {
	if (!text || text === '')
		return '';
	return `${text.charAt(0).toLocaleLowerCase()}${text.slice(1)}`;
}

export function ft_formatObjectIdToDate(id: string) {
	return new Date(parseInt(id.substring(0, 8), 16) * 1000);
}